import styled from 'styled-components';
import DialogContentText from '@material-ui/core/DialogContentText';

export const StyledContextText = styled(DialogContentText)`
  && {
    padding-top: 20px;
  }
`;
